/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * karevi
 * ProfileForm.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {ProfileDTO} from "../../dto/profile/ProfileDTO";
import {SelectField} from "../../../tools/model/form/SelectField";
import Catalog from "../../Catalog";
import Device from "../../Device";
import {TextField} from "../../../tools/model/form/TextField";

export default class AddProfileForm extends AbstractForm<ProfileDTO> {

    constructor(availableCatalogs: Catalog[], availableDevices: Array<Device>, dto?: ProfileDTO) {
        super();

        this.fields.set(ProfileDTO.NAME, new TextField(
            ProfileDTO.NAME,
            (t: Translation) => t.profileName,
            (value) => value.length > 0,
            Type.TEXT,
            true,
            dto?.name ?? "",
            "",
            false,
            (t: Translation) => "erreur : nom du profil non valide"
        ));

        this.fields.set(ProfileDTO.UUID, new TextField(
            ProfileDTO.UUID,
            (t: Translation) => t.uuid,
            () => true,
            Type.TEXT,
            true,
            dto?.uuid ?? "",
            "",
            false,
            (t: Translation) => t.emptyUuidListAddProfile
        ));

        this.fields.set(ProfileDTO.CATALOG_ID, new SelectField<String>(
            availableCatalogs.map(availableCatalog => {
                return {
                    value: availableCatalog.id,
                    name: availableCatalog.title
                }
            }),
            ProfileDTO.CATALOG_ID,
            (t: Translation) => t.assignedCatalog,
            () => true,
            Type.SELECT,
            false,
            true,
            dto?.catalogId,
            undefined,
            false,
            (t: Translation) => t.emptyCatalogListAddProfile
        ));

        if (dto) super.load(dto);
    }

    loadCatalogs(catalogs: Catalog[]) {
        let select: SelectField<String> = this.fields.get(ProfileDTO.CATALOG_ID) as SelectField<String>;
        if (select) {
            select.options = catalogs.map(catalog => {
                return {
                    value: catalog.id,
                    name: catalog.title
                };
            })

            this._notifyListener();
        }
    }

    load(dto: ProfileDTO) {
        super.load(dto);
        console.log("load override");
        let field = this.fields.get(ProfileDTO.CATALOG_ID)
        console.log("load override", field);
        if (field) field.value = dto.catalogId
    }
}
